const ITEMS = [
  "Instant digital delivery",
  "Secure Razorpay checkout",
  "Five launch brands",
  "Nine display currencies",
  "No account required",
  "Region-clear codes",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-display text-sm uppercase tracking-[0.3em] text-muted-foreground/70">
          {item}
        </span>
        <span className="block h-1.5 w-1.5 rotate-45 bg-primary/50" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/[0.07] bg-white/[0.015] py-5"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
